const clicks = () => {
    addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        const link = target.closest('a');

        if (!link) {
            return;
        }

        const href = link.getAttribute('href');
        if (!href) {
            return;
        }

        if (href.startsWith('tel:')) {
            enviaClick('teléfono');
        } else if (href.indexOf('wa.me') || href.indexOf('api.whatsapp')) {
            enviaClick('whatsapp');
        }
    });
}

const enviaClick = (accion: string) => fetch('/wp-admin/admin-ajax.php?action=click', {
    method: 'POST',
    credentials: 'same-origin',
    body: new URLSearchParams({
        tipo: accion,
        titulo: document.title,
        url: location.href,
    }),
})

export default clicks;